import './Navbar.css';

function Navbar() {
  return (
    <div className="navbar">
      <h3>Movies and Vegetables</h3>
    </div>
  );
}

export default Navbar;
